import {ExperimentNames} from '@wix/wix-events-commons-statics'
import {useExperiments} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React from 'react'
import {RegistrationLayoutProps} from './interfaces'
import s from './registration-layout.scss'

export const RegistrationLayout: React.FC<RegistrationLayoutProps> = ({Left, Right}) => {
  const {experiments} = useExperiments()
  const updatedCheckoutSummaryEnabled = experiments.enabled(ExperimentNames.UpdatedCheckoutSummary)

  return (
    <div className={classNames(s.container, {[s.updatedCheckoutSummary]: updatedCheckoutSummaryEnabled})}>
      <div className={updatedCheckoutSummaryEnabled ? s.leftUpdatedCheckoutSummary : s.left}>{Left}</div>
      <div className={updatedCheckoutSummaryEnabled ? s.rightUpdatedCheckoutSummary : s.right}>{Right}</div>
    </div>
  )
}
